import {StatusType} from '@web/slices/productBundle/slice'

export const ProductStatusMap = {
    /** 정산완료 */
    SETTLE_COMPLETE: StatusType.SETTLEMENT_COMPLETED,
    /** 정산예정 */
    SETTLE_SCHEDULE: StatusType.SETTLEMENT_SCHEDULED,
    /** 정산취소완료 */
    CANCEL_COMPLETE: StatusType.SETTLEMENT_CANCELLED,
    /** 정산취소중 */
    CANCEL_SCHEDULE: StatusType.SETTLEMENT_CANCELLING,
}

export const ProductStatusNameMap = {
    /** 정산완료 */
    SETTLE_COMPLETE: '정산완료',
    /** 정산예정 */
    SETTLE_SCHEDULE: '정산예정',
    /** 정산취소중 */
    CANCEL_SCHEDULE: '취소중',
    /** 정산취소완료 */
    CANCEL_COMPLETE: '정산취소',
}

export const SettleObjectNameMap: Record<string, string> = {
    PROD_ORDER: '상품 주문',
    DELIVERY: '배송비',
    EXTRAFEE: '기타 비용',
    WITHDRAW: '결제 수단 출금',
    REFUND: '구매자 환불',
    PL_REFUND: '후불 결제 환불',
    DEDUCTION_RESTORE: '기타 공제 환급',
    PROD_PAY: '상품 결제',
    PURCHASE_REVIEW: '텍스트 리뷰',
    PREMIUM_PURCHASE_REVIEW: '포토/동영상 리뷰',
    REGULAR_PURCHASE_REVIEW: '알림받기 리뷰 추가 적립',
    ONE_MONTH_PURCHASE_REVIEW: '한달사용 텍스트 리뷰',
    ONE_MONTH_PREMIUM_PURCHASE_REVIEW: '한달사용 포토/동영상 리뷰',
    REVIEW: '리뷰 적립',
    ETC_COUPON: '기타 할인',
    QUICK_SETTLE: '빠른정산',
    QUANTITY_CANCEL: '수량 취소',
    DIFFERENCE_SETTLE: '차액 정산',
    DEPOSIT_SETTLE: '보증금',
    RENTAL_ORDER: '렌탈 주문',
    MANUAL_ORDER: '수기 주문',
    RENTAL_SCHEDULED_ORDER: '월 렌탈료 주문',
    PREFERENTIAL_COMMISSION: '우대 수수료 환급',
    POINT_ACCUMULATION: '포인트 적립',
}

export function getSettleObjectName(key?: string): string {
    return key ? SettleObjectNameMap[key] || key : ''
}

export const SearchPlaceholder = '상품/배송비 검색'
